import { useEffect, useRef, useState } from "react";
import { Search, X, RefreshCw } from "lucide-react";
import { useContacts } from "../../contexts/ContactsContext";
import ContactsAdvancedFilterButton from "../ContactsAdvancedFilterButton";
import { cn } from "../../../../utils/utils";

/**
 * Thanh công cụ trên cùng của panel bên phải: search + filter + reload.
 */
const ContactsToolbar = ({
  title,
  subtitle,
  onReload,
  loading = false,
  showFilter = true,
  rightExtra = null,
}) => {
  const { search, setSearch } = useContacts();
  const [localSearch, setLocalSearch] = useState(search);
  const debounceRef = useRef(null);

  // Debounce 300ms
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      if (localSearch !== search) setSearch(localSearch);
    }, 300);
    return () => clearTimeout(debounceRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localSearch]);

  // Sync khi search bên ngoài đổi (clear khi chuyển tab chẳng hạn)
  useEffect(() => {
    if (search !== localSearch) setLocalSearch(search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <div className="px-4 py-3 border-b border-gray-100 bg-white flex items-center gap-2 flex-wrap">
      <div className="flex-1 min-w-[240px]">
        {title && (
          <div className="text-sm font-semibold text-gray-900">{title}</div>
        )}
        {subtitle && (
          <div className="text-[12px] text-gray-500 mt-0.5">{subtitle}</div>
        )}
      </div>

      <div className="relative">
        <Search
          size={14}
          className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
        />
        <input
          type="text"
          value={localSearch}
          onChange={(e) => setLocalSearch(e.target.value)}
          placeholder="Tìm theo tên hoặc SĐT…"
          className="pl-8 pr-8 h-8 text-[13px] border border-gray-200 rounded-md w-64 focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-300 bg-white"
        />
        {localSearch && (
          <button
            onClick={() => setLocalSearch("")}
            className="absolute right-1.5 top-1/2 -translate-y-1/2 p-0.5 rounded hover:bg-gray-100"
            aria-label="Xoá tìm kiếm"
          >
            <X size={13} className="text-gray-400" />
          </button>
        )}
      </div>

      {showFilter && <ContactsAdvancedFilterButton />}

      {onReload && (
        <button
          onClick={onReload}
          disabled={loading}
          className={cn(
            "h-8 w-8 inline-flex items-center justify-center rounded-md border border-gray-200 text-gray-600 hover:bg-gray-50",
            loading && "opacity-60",
          )}
          title="Tải lại"
        >
          <RefreshCw size={14} className={cn(loading && "animate-spin")} />
        </button>
      )}

      {rightExtra}
    </div>
  );
};

export default ContactsToolbar;
